"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-empty-function */
var react_1 = __importStar(require("react"));
var form_1 = require("../../utils/form");
var request_1 = require("../../utils/request");
var WithErrorHandler_1 = require("../WithErrorHandler");
var typeRange = 'text|tel|number';
var InputRow = react_1.memo(function (props) {
    var _a;
    var inputRef = react_1.useRef(null);
    var _b = __read(react_1.useState(false), 2), showDelete = _b[0], setShowDelete = _b[1];
    react_1.useEffect(function () {
        var _a;
        if (typeof inputRef.current != 'undefined' &&
            inputRef.current &&
            typeof props.defaultValObj != 'undefined' &&
            typeof props.defaultValObj.inputVal != 'undefined') {
            inputRef.current.value = props.defaultValObj.inputVal;
            ((_a = props.defaultValObj) === null || _a === void 0 ? void 0 : _a.inputVal) !== ''
                ? setShowDelete(true)
                : setShowDelete(false);
            props.inputFun && props.inputFun(props.defaultValObj.inputVal);
        }
    }, [props.defaultValObj]);
    react_1.useEffect(function () {
        if (props.defaultValObj.encrptionVal) {
            inputRef.current.value = props.defaultValObj.encrptionVal;
        }
    }, [(_a = props.defaultValObj) === null || _a === void 0 ? void 0 : _a.encrptionVal]);
    var inputHandle = react_1.useCallback(function (event) {
        form_1.InputChangeHandle(event).then(function (val) {
            props.inputFun && props.inputFun(val);
            if (!showDelete && val) {
                setShowDelete(true);
            }
            else if (!val && showDelete) {
                setShowDelete(false);
            }
        });
    }, [props.inputFun, showDelete]);
    var onFocusInput = react_1.useCallback(function (event) {
        if (typeof props.onFocusFn === 'function') {
            props.onFocusFn(event);
        }
    }, [props.onFocusFn]);
    var onBlurInput = react_1.useCallback(function (event) {
        if (typeof props.onBlurFn === 'function') {
            props.onBlurFn(event);
        }
    }, [props.onBlurFn]);
    var resetInput = react_1.useCallback(function () {
        // input框旁边清除按钮
        if (typeof inputRef.current != 'undefined' && inputRef.current) {
            inputRef.current.value = '';
            props.inputFun && props.inputFun('');
            if (showDelete) {
                setShowDelete(false);
            }
        }
    }, [props.inputFun, showDelete]);
    return (react_1.default.createElement("section", { className: "newcar_ui_inputRow " + props.cn },
        props.labelStr && (react_1.default.createElement("label", { dangerouslySetInnerHTML: { __html: props.labelStr } })),
        react_1.default.createElement("div", { className: 'newcar_ui_inputWrap' },
            react_1.default.createElement("div", { className: 'newcar_ui_txtWrap' },
                react_1.default.createElement("input", { type: typeRange.indexOf(props.type ? props.type : 'text') === -1
                        ? 'text'
                        : props.type, className: "newcar_ui_txt " + props.inputCN, placeholder: props.placeholder, onChange: inputHandle, onFocus: onFocusInput, onBlur: onBlurInput, maxLength: props.maxLength === 0 ||
                        typeof props.maxLength == 'undefined' ||
                        (typeof props.maxLength == 'string' &&
                            isNaN(parseInt(props.maxLength)))
                        ? undefined
                        : typeof props.maxLength == 'string'
                            ? parseInt(props.maxLength)
                            : props.maxLength, ref: inputRef, autoComplete: props.isAutoComplete ? 'on' : 'off' }),
                react_1.default.createElement("span", { className: "newcar_ui_deleteBtn " + (showDelete ? '' : 'hide'), onClick: resetInput })),
            props.children)));
});
InputRow.defaultProps = {
    labelStr: '',
    type: 'text',
    cn: '',
    inputCN: '',
    maxLength: 0,
    placeholder: '请输入',
    inputFun: function () { },
    defaultValObj: {
        inputVal: '',
    },
    isAutoComplete: false,
};
var SelectRow = react_1.memo(function (props) {
    return (react_1.default.createElement("section", { className: "newcar_ui_inputRow " + props.cn },
        props.labelStr && (react_1.default.createElement("label", { dangerouslySetInnerHTML: { __html: props.labelStr } })),
        react_1.default.createElement("div", { className: 'newcar_ui_inputWrap' },
            react_1.default.createElement("span", { className: "newcar_ui_selectDom " + props.selectCN + " " + (props.selectName ? '' : 'newcar_ui_default'), onClick: props.clickFun }, props.selectName ? props.selectName : props.placeholder))));
});
SelectRow.defaultProps = {
    labelStr: '品牌车型',
    cn: '',
    selectCN: '',
    placeholder: '请选择',
    selectName: '',
    clickFun: function () { },
};
var RealnameRow = react_1.memo(function (props) {
    return react_1.default.createElement(InputRow, __assign({}, props));
});
RealnameRow.defaultProps = {
    labelStr: '您的姓名',
    type: 'text',
    cn: '',
    inputCN: '',
    maxLength: 0,
    placeholder: '请输入姓名',
    inputFun: function () { },
    defaultValue: {
        inputVal: '',
    },
};
var TelRow = react_1.memo(function (props) {
    return react_1.default.createElement(InputRow, __assign({}, props));
});
TelRow.defaultProps = {
    labelStr: '手机号码',
    type: 'tel',
    cn: '',
    inputCN: '',
    maxLength: 11,
    placeholder: '请输入手机号码',
    inputFun: function () { },
    defaultValObj: {
        inputVal: '',
    },
};
var messageCodeFlag = true, codeTimer = null;
var MessageCodeRow = react_1.memo(function (props) {
    var _a = __read(react_1.useState('获取验证码'), 2), codeBtnStr = _a[0], setCodeBtnStr = _a[1];
    var getCode = react_1.useCallback(function () {
        // 获取验证码
        if (!messageCodeFlag || codeBtnStr !== '获取验证码') {
            return false;
        }
        form_1.checkForm([
            { id: 'tel', value: props.tel, rule: 'tel', require: true },
        ]).then(function () {
            var _a;
            messageCodeFlag = false;
            if (!props.ajaxUrl) {
                messageCodeFlag = true;
                props.errorFun('缺少参数：缺少获取短信验证码接口地址ajaxUrl');
                return false;
            }
            request_1.request(props.ajaxUrl, __assign(__assign((_a = {}, _a[props.ajaxKey] = props.tel, _a), (props.ajaxParams || {})), { rand: new Date().getTime() }), 'jsonp')
                // eslint-disable-next-line max-nested-callbacks
                .then(function (response) {
                messageCodeFlag = true;
                if (response.code === 0) {
                    countDownFun();
                }
                else {
                    props.errorFun(response.message);
                }
            })
                // eslint-disable-next-line max-nested-callbacks
                .catch(function (error) {
                messageCodeFlag = true;
                console.log(error);
            });
        }, function () {
            props.errorFun('请输入手机号码');
        });
    }, [props]);
    var countDownFun = function () {
        // 倒计时
        var num = 60, str = '';
        codeTimer = setInterval(function () {
            num--;
            if (num <= 0) {
                str = '获取验证码';
                clearInterval(codeTimer);
            }
            else {
                str = num + "\u79D2\u540E\u91CD\u65B0\u83B7\u53D6";
            }
            setCodeBtnStr(str);
        }, 1000);
        setCodeBtnStr(num + "\u79D2\u540E\u91CD\u65B0\u83B7\u53D6");
    };
    return (react_1.default.createElement(InputRow, __assign({}, props),
        react_1.default.createElement("a", { className: "newcar_ui_codeBtn " + (codeBtnStr == '获取验证码' ? '' : 'newcar_ui_disable'), onClick: getCode }, codeBtnStr)));
});
MessageCodeRow.defaultProps = {
    tel: '',
    ajaxKey: 'phone',
    labelStr: '验证码',
    type: 'text',
    cn: '',
    inputCN: '',
    maxLength: 6,
    placeholder: '请输入',
    errorFun: function (errorMessage) { },
    inputFun: function () { },
    ajaxUrl: '',
    defaultValue: {
        inputVal: '',
    },
};
var Radio = react_1.memo(function (props) {
    var _a = __read(react_1.useState(false), 2), checked = _a[0], setChecked = _a[1];
    react_1.useEffect(function () {
        if (typeof props.default !== 'undefined') {
            setChecked(props.default);
        }
    }, [props.default]);
    var clickFun = react_1.useCallback(function () {
        var status = !checked;
        setChecked(status);
        props.callback && props.callback(status);
    }, [checked]);
    return (react_1.default.createElement("div", { className: "newcar_ui_RadioWrap " + props.cn },
        react_1.default.createElement("span", { className: "newcar_ui_redio " + (typeof checked === 'boolean' && checked === true
                ? 'newcar_ui_redio_cur'
                : ''), onClick: clickFun }),
        props.children));
});
Radio.defaultProps = {
    cn: '',
    default: false,
};
exports.default = {
    InputRow: WithErrorHandler_1.WithErrorHandler(react_1.memo(InputRow)),
    SelectRow: WithErrorHandler_1.WithErrorHandler(react_1.memo(SelectRow)),
    RealnameRow: WithErrorHandler_1.WithErrorHandler(react_1.memo(RealnameRow)),
    TelRow: WithErrorHandler_1.WithErrorHandler(react_1.memo(TelRow)),
    MessageCodeRow: WithErrorHandler_1.WithErrorHandler(react_1.memo(MessageCodeRow)),
    RadioRow: WithErrorHandler_1.WithErrorHandler(react_1.memo(Radio)),
};
